import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import { APIBaseURL, AccessToken, ImgBaseURL } from "../Config";
import Swal from "sweetalert2";
import axios from "axios";
import EirMain from "./EIRMain"; // import your component
import * as html2pdf from "html2pdf.js";

export default function EirReport() {
  const pdfRef = useRef();
  const [type, setType] = useState("rake_in");
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState([]); // default filter
  const [showModal, setShowModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const GetData = async (page = 1) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://ctas.live/backend/api/eir/report?filter=${filter}&type=${filter}&page=` +
          page,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: `${AccessToken}`,
          },
        }
      );
      if (response.data.status === "success") {
        setData(response.data.data || []);
        setType(filter); // Update type for display
      } else {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "Something Went Wrong.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Fetch Error!",
        text: error.message || "Something went wrong while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filter) {
      GetData(filter);
    }
    // alert(filter)
  }, [filter]);

  useEffect(() => {
    setFilter("rake_in");
  }, []);

  const handlePrint = () => {
    window.print();
    // const printContent = document.getElementById('eir-to-print').innerHTML;
    // const originalContent = document.body.innerHTML;

    // document.body.innerHTML = printContent;
    // document.body.innerHTML = originalContent;
    // window.location.reload(); // Modal को फिर से लोड करने के लिए
  };

  const handleDownload = () => {
    const iframe = document.getElementById("tallySheetFrame");
    const iframeContent = iframe.contentWindow.document.body;

    const opt = {
      margin: [0.2, 0.2, 0.2, 0.2],
      filename: "EIR.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 3,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "a3",
        orientation: "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };
    html2pdf().set(opt).from(iframeContent).save();
  };

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row my-3">
                  <div className="nav-align-top">
                    <ul className="nav nav-pills flex-md-row gap-2 gap-lg-0">
                      <li>
                        <button
                          className={`btn me-3 ${
                            filter === "rake_in"
                              ? "btn-primary"
                              : "btn-label-primary"
                          }`}
                          onClick={() => setFilter("rake_in")}
                        >
                          Rake In
                        </button>
                      </li>
                      <li>
                        <button
                          className={`btn me-3 ${
                            filter === "rake_out"
                              ? "btn-primary"
                              : "btn-label-primary"
                          }`}
                          onClick={() => setFilter("rake_out")}
                        >
                          Rake Out
                        </button>
                      </li>
                      <li>
                        <button
                          className={`btn me-3 ${
                            filter === "gate_in"
                              ? "btn-primary"
                              : "btn-label-primary"
                          }`}
                          onClick={() => setFilter("gate_in")}
                        >
                          Gate
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between mb-3">
                  <div className="card"></div>
                </div>

                <div className="row">
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="row mb-3 align-items-center text-primary">
                        <div className="col-sm-6  col-lg-3">
                          <div
                            className="card"
                            style={{
                              backgroundColor: "rgba(40, 167, 69, 0.2)",
                            }}
                          ></div>
                        </div>
                        <div className="col-sm-6 col-lg-3">
                          <div
                            className="card"
                            style={{
                              backgroundColor: "rgba(23, 162, 184, 0.2)",
                            }}
                          >
                            {" "}
                          </div>
                        </div>
                        <div className="col-4">
                          <div
                            className="card"
                            style={{
                              backgroundColor: "rgba(0, 123, 255, 0.2)",
                            }}
                          >
                            {" "}
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive text-nowrap">
                        <table className="table table-hover table-font table-striped">
                          <thead>
                            <tr className="table-primary">
                              <td>S.No.</td>
                              <td>Category</td>
                              <td>Container_no</td>
                              <td>Container_size</td>

                              {/* ✅ Show only if filter is gate_in */}
                              {filter === "gate_in" && (
                                <>
                                  <td>Vehicle No</td>
                                  <td>Gate No</td>
                                </>
                              )}

                              <td>Action</td>
                            </tr>
                          </thead>

                          <tbody>
                            {Data?.data?.map((report, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{(report.type || "").toUpperCase()}</td>
                                <td>{report.container_no ?? report.ctrno}</td>
                                <td>
                                  {report.container_size ?? report.ctrsize}
                                </td>
                                {filter === "gate_in" && (
                                  <>
                                    <td>
                                      {(report.vehicle_no || "").toUpperCase()}
                                    </td>
                                    <td>{report.gate_no}</td>
                                  </>
                                )}
                                <td>
                                  <button
                                    onClick={() => {
                                      setSelectedReport(report);
                                      openModal();
                                    }}
                                    className="btn btn-info btn-label-primary"
                                  >
                                    View
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {Data && Data.data && (
                          <div className="container mt-4">
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing {Data.from} to {Data.to} of{" "}
                                  {Data.total} entries
                                </div>
                              </div>
                              <div className="col-10 m-auto mt-2">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <ul className="pagination ">
                                    {Data &&
                                      Data.links &&
                                      Data.links.map((link, q) => {
                                        let showData =
                                          Data.links.length == q + 1
                                            ? "Next"
                                            : q == 0
                                            ? "Previous"
                                            : link.label;
                                        return (
                                          <li
                                            key={q}
                                            className={`paginate_button page-item ${
                                              link.active === true
                                                ? "active"
                                                : ""
                                            }  ${
                                              showData == "Next" &&
                                              Data.current_page ==
                                                Data.last_page
                                                ? "disabled"
                                                : showData == "Previous" &&
                                                  Data.current_page == 1
                                                ? "disabled"
                                                : ""
                                            } `}
                                          >
                                            <button
                                              onClick={() => {
                                                showData == "Previous"
                                                  ? GetData(
                                                      Data.current_page - 1
                                                    )
                                                  : showData == "Next"
                                                  ? GetData(
                                                      Data.current_page + 1
                                                    )
                                                  : GetData(link.label);
                                              }}
                                              aria-controls="DataTables_Table_0"
                                              role="link"
                                              aria-current="page"
                                              data-dt-idx={0}
                                              tabIndex={0}
                                              className="page-link"
                                            >
                                              {showData}
                                            </button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {showModal && (
                          <div
                            className="modal-overlay"
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              zIndex: 1050,
                              backgroundColor: "rgba(0,0,0,0.5)",
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            <div
                              className="modal-content bg-white p-4"
                              style={{
                                maxWidth: "800px",
                                margin: "50px auto",
                                borderRadius: "10px",
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="modal-title">
                                  {type} Report Details
                                </h5>
                                <div>
                                  <button
                                    className="btn btn-info me-2"
                                    onClick={() => {
                                      const iframe =
                                        document.getElementById(
                                          "tallySheetFrame"
                                        );
                                      if (iframe && iframe.contentWindow) {
                                        iframe.contentWindow.focus();
                                        iframe.contentWindow.print();
                                      }
                                    }}
                                  >
                                    Print
                                  </button>

                                  <button
                                    className="btn btn-danger"
                                    onClick={closeModal}
                                  >
                                    X
                                  </button>
                                  <button
                                    onClick={handleDownload}
                                    className="btn btn-label-info ms-1"
                                  >
                                    Down...
                                  </button>
                                </div>
                              </div>
                              <div id="eir-to-print">
                                <iframe
                                  ref={pdfRef}
                                  id="tallySheetFrame"
                                  src={`/eir-main?data=${JSON.stringify(
                                    selectedReport
                                  )}`}
                                  title="Tally Sheet"
                                  width="100%"
                                  height="700px"
                                  style={{ border: "none" }}
                                />
                                {/* <EirMain data={selectedReport} /> */}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="View-Modal"
                tabIndex={-1}
                style={{ display: "none" }}
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary py-3">
                      <h5 className="modal-title" id="exampleModalLabel1">
                        Seal Image
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        {selectedReport?.seal_1_image && (
                          <div className="col-4">
                            <img
                              src={
                                ImgBaseURL + "/" + selectedReport?.seal_1_image
                              }
                              className="w-100"
                              alt=""
                            />
                          </div>
                        )}

                        {selectedReport?.seal_2_image && (
                          <div className="col-4">
                            <img
                              src={
                                ImgBaseURL + "/" + selectedReport?.seal_2_image
                              }
                              className="w-100"
                              alt=""
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer bg-label-primary py-3">
                      <button
                        type="button"
                        className="btn btn-outline-secondary waves-effect"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
